module.exports = __webpack_public_path__ + "img/feedback.06086f59.jpg";